import React from 'react'

function Privacy() {
  return (
    <div className='bg-all-container'>Privacy</div>
  )
}

export default Privacy